// extracted by mini-css-extract-plugin
export default {"list-container":"NotiList_list-container__XzMmF","noti-container":"NotiList_noti-container__ScpB7","time":"NotiList_time__C9bqV"};